module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio42-dce596c6b273436ebbe71c295533ff95.m4a";